<template lang="pug">
    div.col-md-4
        div.box
            div.box-header.dker.b-b
                h3 Top Purchased Product
                small Most purchased products by quantity
            div.box-tool
                export-chart(chart="top_purchased")

            div.box-body
                chart(:options="options", ref="chart")
</template>

<script>
import { mapGetters } from 'vuex';
import mixins from './mixins';

export default {
    mixins: [mixins],

    computed: {
        ...mapGetters('reportProduct', ['chartTopProducts']),

        options() {
            return {
                title: {
                    show: false,
                },
                color: ['#0cc2aa'],
                tooltip: {
                    trigger: 'axis',
                    formatter: '{b} <br/> {a} : {c}',
                    axisPointer: {
                        type: 'shadow',
                    },
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '4%',
                    top: '10%',
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'value',
                        name: 'Quantity',
                        nameLocation: 'middle',
                        nameGap: 20,
                    },
                ],
                yAxis: [
                    {
                        type: 'category',
                        data: this.chartTopProducts.yAxisData,
                        name: 'Products',
                        nameLocation: 'end',
                        axisTick: {
                            alignWithLabel: true,
                        },
                        axisLabel: {
                            formatter: (value, index) => {
                                return this.displayShortName(value);
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: 'Quantity',
                        type: 'bar',
                        barWidth: '60%',
                        data: this.chartTopProducts.seriesData,
                    },
                ],
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.echarts {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/top-purchased-products.vue